export default "/logo-placeholder.f294a46ca01351f89064f69674934b8d.svg";